module.exports = __webpack_public_path__ + "static/media/img_d_rocket@2x.2c50b7fe.png";